import React from "react";


export default function Footer() {
  return (
    <footer className="footer-section">
      <div className="footer-container">

        {/* About / Summary */}
        <div className="footer-about">
          <h2>Aspire Homes</h2>
          <p>
            We help you find your dream home quickly with experienced agents,
            exclusive offers, and happy clients. Your satisfaction is our priority.
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-links">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="#gallery">Our Gallery</a></li>
            <li><a href="#chooseus">Why Choose Us</a></li>
            <li><a href="#testimonials">Testimonials</a></li>
            <li><a href="#contact">Contact Us</a></li>
          </ul>
        </div>

        {/* Highlights */}
        <div className="footer-highlights">
          <h3>Why Choose Us?</h3>
          <ul>
            <li>Quick Deals</li>
            <li>Experience</li>
            <li>Exclusive Offers</li>
            <li>Happy Clients</li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-contact">
          <h3>Contact Us</h3>
          <p>Email: Info@aspirehomes.co, wwww.aspirehomes.co</p>
          <p>Phone: Amrinder 0451 518 901 ,Varinder 0403 235 632</p>
          <div className="footer-social">
            <a href="#"><img src="https://img.icons8.com/ios-filled/24/ffffff/facebook-new.png" alt="Facebook" /></a>
            <a href="#"><img src="https://img.icons8.com/ios-filled/24/ffffff/twitter.png" alt="Twitter" /></a>
            <a href="#"><img src="https://img.icons8.com/ios-filled/24/ffffff/instagram-new.png" alt="Instagram" /></a>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        <p>
          &copy; {new Date().getFullYear()} Aspire Homes. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
